<template>
  <Modal v-model="modal" :mask-closable="true" :footer-hide="true" :closable="false" width="450px" >
    <div class="down">
      <img :src="imgurl" alt class="img" />
      <a class="btn" href="/Member/RZJFund/DownLoadPoster">{{$t('btn.b84')}}</a>
    </div>
  </Modal>
</template>

<script>
export default {
  props: ["imgurl"],
  data() {
    return {
      modal: false
    };
  }
}
</script>

<style lang="less" scoped>
/deep/.ivu-modal .ivu-modal-body {
  padding: 0;
}
/deep/.ivu-modal{
    top: 60px;
}
.down {
    .img{
        width: 450px;
    }
  .btn {
    width: 100%;
    height: 60px;
    text-align: center;
    line-height: 60px;
    font-size: 18px;
    color: #ffe9e6;
    background: #fc8375;
    cursor: pointer;
    display: inline-block;
  }
}
</style>
